/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, RoutePath } from "../../../utility/Constant";

const SelectionUniquePage = () => {
  const { selectionApi } = apiPath;
  const [selectionUniqueData, selectionUniqueLoading] = useFetch(selectionApi);
  const [filteredData, setFilteredData] = useState();
  let { id } = useParams();
  const { selectionContent } = RoutePath


  useEffect(() => {
    setFilteredData(selectionUniqueData?.filter((item) => item._id === id)[0]);
  }, [selectionUniqueData, id]);

  if (selectionUniqueLoading || !filteredData?._id) {
    return <Loading />;
  }

  const { title, short_description, image, _id } = filteredData ?? {};

  const data = [
    {
      elementType: "input",
      label: "Name",
      type: "Text",
      name: "title",
      defaultValue: title,
      required: false,
    },
    {
      elementType: "textField",
      label: "short description",
      type: "Text",
      name: "short_description",
      defaultValue: short_description,
      required: false,
    },
    {
      elementType: "file",
      label: `Image`,
      name: "image",
      type: "file",
      fullCol: true,
      defaultValue: image,
      required: false,
    },
  ];

  const update = (data) => {
    const { image, ...rest } = data;
    rest.image = {
      url: image,
    };
    updateData(selectionApi, rest, _id);
    setTimeout(() => {
      window.location.href = "/" + selectionContent;
    }, 800);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default SelectionUniquePage;
